<div class="content-section disable-auto-scroll" [ngClass]="layoutService.expandedMenu ? 'expand' : ''">
    <app-trial-license-warning></app-trial-license-warning>
    <lib-campaigns></lib-campaigns>
    <div class="title-section h-100 title-bar title-bar-nav" id='title-bar'>
        <div class="title-div d-flex align-items-center">
            <div class="col p-0 d-flex justify-content-between align-items-center ">
                <div class="p-0">
                    <a (click)="backToQuestionnaireList()">
                        <img src="assets/ph-bhp-layout/svg/back.svg" class="svg">
                        {{ 'CHECK.BACK' | translate}}

                    </a>
                    <h2 class="background_title" *ngIf="isNewQuestionnaire()"> {{ 'CHECK.CONFIGURE.NEW' | translate}} </h2>
                    <h2 class="background_title" *ngIf="!isNewQuestionnaire()"> {{ 'CHECK.CONFIGURE.EDIT' | translate}} </h2>
                </div>
                <div class="col-auto d-flex justify-content-md-end justify-content-sm-start">
                    <div class="col-auto institution-name pl-0">
                    </div>
                </div>
            </div>
            <div class="btn-delete-icon" *ngIf="!isNewQuestionnaire()">
                <a (click)="deleteQuestionnaire()">
                    <img src="assets/ph-bhp-layout/svg/icon-delete.svg">
                </a>
            </div>
        </div>
    </div>

    <div class="questionnaire" *ngIf="questionnaire">
        <div class="details-container">
            <div class="space-between">
                <h2 *ngIf="isNewQuestionnaire()" class="background_title mt-0"> {{ 'CHECK.EDITOR.ADD_DETAILS' | translate}} </h2>
                <h2 *ngIf="!isNewQuestionnaire()" class="background_title mt-0"> {{ 'CHECK.EDITOR.EDIT_DETAILS' | translate}} </h2>
                <div class="notes-section">
                    <p class="label">{{ 'CHECK.EDITOR.SHOW_NOTES_REPORT' | translate}}</p>
                    <p><mat-slide-toggle [(ngModel)]="questionnaire.showNotes">{{ (questionnaire.showNotes ?
                            'CONFIGURE.ACTIVE' : 'CONFIGURE.INACTIVE') | translate }}</mat-slide-toggle></p>
                </div>
            </div>

            <div class="comment">
                <label class="input-floating w-25">
                    <input [(ngModel)]="questionnaire.questionnaireName" type="text" class="form-input comment-input"
                        placeholder="'CHECK.EDITOR.QUESTIONNAIRE_NAME' | translate" />
                    <span>{{ 'CHECK.EDITOR.QUESTIONNAIRE_NAME' | translate }} *</span>
                </label>
            </div>
        </div>

        <div class="questions-container mt-4">
            <div class="questions-header">
                <h2 class="background_title m-0"> {{ 'CHECK.EDITOR.QUESTIONS' | translate}} </h2>
                <div class="buttons-section">
                    <button class="btn btn-continue-bordered-bd mr-4" (click)="addCaption()"><img
                            src="assets/icons/addOutline.svg" class="pr-1"> {{ 'CHECK.EDITOR.ADD_CAPTION' | translate
                        }}</button>
                    <button class="btn btn-continue-bordered-bd" (click)="addQuestion()"><img
                            src="assets/icons/addOutline.svg" class="pr-1"> {{ 'CHECK.EDITOR.ADD_QUESTION' | translate
                        }}</button>
                </div>
            </div>

            <div class="questions-list empty-questions mt-4" *ngIf="!questionnaire.questions || questionnaire.questions.length === 0">
                <a>{{ 'CHECK.EDITOR.ADD_CAPTION_QUESTION' | translate }}</a>
            </div>

            <div cdkDropList class="questions-list mt-4" [cdkDropListData]="questionnaire.questions" *ngIf="questionnaire.questions && questionnaire.questions.length > 0"
                (cdkDropListDropped)="drop($event)">
                <div class="row question-chip" *ngFor="let item of questionnaire.questions" cdkDrag>
                    <ng-container *ngIf="!isQuestionDeleted(item)">
                        <div class="d-flex col-1 position">
                            {{ item.questionPosition }}
                        </div>
                        <div class="col-11 question row mb-2" [ngClass]="item.isCaption ? 'caption-box' : 'question-box'">
                            <div class="col-1"><img cdkDragHandle class="drag-icon" src="assets/icons/dragDropIcon.svg">
                            </div>
                            <ng-container *ngIf="item.isCaption">
                                <div class="col-9 statement">{{ item.statement }}</div>
                            </ng-container>
                            <ng-container *ngIf="!item.isCaption">
                                <div class="col-4 statement">{{ item.statement }}</div>
                                <div class="col-5 type d-flex">
                                    <div class="separator mr-4"></div>
                                    {{ getQuestionType(item.questionTypeId) | translate }}
                                </div>
                            </ng-container>
                            <div class="col-2 d-flex justify-content-end buttons">
                                <a class="btn-edit-icon mr-1" (click)="editItem(item)">
                                    <img src="assets/ph-bhp-layout/svg/icon-edit-fill.svg">
                                </a>
                                <a class="btn-edit-icon" (click)="deleteItem(item)">
                                    <img src="assets/ph-bhp-layout/svg/icon-delete-fill.svg">
                                </a>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>

        <ng-template #deleteModal>
            <div class="mb-4 justify-content-between align-items-center p-0">
              <h5 class="modal-title">{{ 'ERROR_MESSAGES.CHECK.DELETE_QUESTIONNAIRE_TITLE' | translate }}</h5>
            </div>
            <div class="pb-2">
              <p class="check-text"> {{ 'ERROR_MESSAGES.CHECK.DELETE_QUESTIONNAIRE_CONFIRMATION' | translate }} </p>
            </div>
            <div class="d-flex justify-content-end">
              <div class="align-items-end d-flex">
                <button (click)="modalRef.hide()" class="btn-cancel-bordered-bd separate-buttons">{{ 'BUTTON.NO' | translate }}</button>
                <button (click)="deleteQuestionnaireConfirmed(); modalRef.hide()" class="btn-bd-empty">{{ 'BUTTON.YES' | translate }}</button>
              </div>
            </div>
          </ng-template>
    </div>

    <div class="footer">
        <button type="button" class="btn btn-cancel mr-4 d-flex align-items-center" (click)="cancelQuestionnaire()">{{ 'CHECK.EDITOR.CANCEL' | translate }} </button>
        <button type="button" class="btn btn-confirm btn-confirm-custom d-flex align-items-center" [ngClass]="isSaveDisabled() ? 'disabled' : ''" (click)="saveQuestionnaire()"> {{ 'CHECK.EDITOR.SAVE_CHANGES' | translate }} </button>
    </div>
</div>

<lib-caption-offcanvas [isCollapsed]="isCaptionCollapsed" (childData)="onCaptionHandler($event)" [caption]="captionData"></lib-caption-offcanvas>
<hygiene-check-question-manager *ngIf="showQuestionManager"  [questionnaire]="questionnaire" [editQuestion]="editQuestion"
                                [questionTypes]="questionTypes" (closeQuestionManager)="closeQuestionManager($event)">
</hygiene-check-question-manager>
